<script lang="ts">
  import { onMount } from 'svelte';

  import Popup from './Popup.svelte'
  import {BigNumber, ethers} from "ethers";

  import { createEventDispatcher } from 'svelte';

  export let show = false;
  export let allocation: string;
  export let allowance: string;
  export let rate: string;

  let newStake = null;
  let yiedlToConvert: ethers.BigNumber = null;
  // let increase: boolean;
  let difference;
  let disabled = true;
  let approveButton = false;
  let notEnough = false;
  let differenceAbsStr: string = null;
  let usdcToReceive: string = null;

  let rateBn: ethers.BigNumber;
  let allocBn: ethers.BigNumber;
  let allowanceBn: ethers.BigNumber;

	const dispatch = createEventDispatcher();

	function submit() {
		dispatch('submit', { yiedlToConvert: !!newStake && bn('' + newStake) });
	}

    function approve() {
        dispatch('approve');
    }

	function cancel() {
		dispatch('cancel');
	}

    function bn(newStake: any) {
      return ethers.utils.parseUnits(newStake, 6);
    }

    function allowanceOk(inputValue: any) {
      try{
        return bn(inputValue ? inputValue : "0").lte(bn(allowance))
      } catch (error) {
        return ethers.constants.Zero
      }
    }

    function allocationOk(inputValue: any) {
      try{
        return bn(inputValue ? inputValue : "0").lte(bn(allocation))
      } catch (error) {
        return ethers.constants.Zero
      }
    }

    function convertedUsdc(inputValue: any) {
      let inputAmt: BigNumber
      try {
        inputAmt = bn(inputValue ? inputValue : "0");
      } catch (error) {
        inputAmt = ethers.constants.Zero
      }
      const rateBn = bn(rate);
      const intermediate1 = inputAmt.mul(rateBn).div(BigNumber.from("1000000"));
      return ethers.utils.formatUnits(intermediate1, 6);
    }

    function inputValid(inputValue: any) {
      try {
        bn(inputValue);
        return true;
      } catch (error) {
        return false;
      }
    }

  $: {
    try {
      // newStakeFloat = !!newStake && bn('' + newStake);

      // usdcToReceive =
      //         newStake ?
      //         convertedUsdc(newStake) : "0";

      disabled = newStake === null || newStake === '';

    } catch (error) {
        console.log("ERROR===", error);
      differenceAbsStr = null;
      // usdcToReceive = null;
      disabled = true;
      // approveButton = false;
      // notEnough = false;
    }
  } 
</script>

<Popup on:cancel={cancel} on:submit={submit} show={show}>
  <div>
    <div class="text-lg">
      Rewards Allocation: {allocation}
    </div>
    <div class="text-sm">
      Allowance: {bn(allowance).eq(ethers.constants.MaxUint256) ? "✓" : allowance}
    </div>
    <div class="mt-3 __text-center sm:mt-5">
      <div class="mt-1 flex rounded-md shadow-sm">
        <span class="relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-gray-50">Convert</span>
        <div class="-ml-px relative flex items-stretch flex-grow focus-within:z-10">
          <input type="text" autocomplete="off" bind:value={newStake} name="stake" id="stake" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-r-md pl-3 sm:text-sm border-gray-300"
                 placeholder="Yiedl amount to convert">
        </div>

      </div>
      <div class="text-right text-xs text-blue-800">
        <button
                on:click={()=>{newStake = allocation}}>
          max
        </button>
      </div>
      <p class="mt-1 text-sm text-gray-500 mb-1" id="email-description">

        <!--{bn(newStake ? newStake : "0").gte(allocBn)} # not enough-->
        {#if newStake && !inputValid(newStake)}
          <p class="text-sm text-pink-700">
          Please enter a valid number.
          </p>

            {:else if allowanceOk(newStake) && allocationOk(newStake) && !disabled }
            <p class="text-sm">
              You will receive {convertedUsdc(newStake)} USDC.
            </p>
              {:else if (allowanceOk(newStake) && !allocationOk(newStake) && !disabled)}
              <p class="text-sm text-pink-700">
                Cannot convert more than your allocation.
              </p>
              {:else if (!allowanceOk(newStake) &&!disabled)}
              <p class="text-xs text-pink-700">
                Conversion amount is more than allowance. Please first increase the amount of allowance the conversion handler can manage for you.
              </p>
            {/if}
      </p>
    </div>
  </div>
  {#if (!allowanceOk(newStake))}
  <div class="mt-5 sm:mt-6">
    <button on:click={approve} type="button" disabled={disabled} class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 disabled:bg-indigo-300 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
      Allow
    </button>
  </div>
    {:else }
    <div class="mt-5 sm:mt-6">
      <button on:click={submit} type="button" disabled={disabled || (!allocationOk(newStake))} class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 disabled:bg-indigo-300 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
        Convert
      </button>
    </div>
    {/if}
  <div class="mt-5 sm:mt-6">
    <button on:click={cancel} type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
      Cancel
    </button>
  </div>
</Popup>
